module.exports = __webpack_public_path__ + "img/intro18.f31ca735.jpg";